<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App",
  // methods: {
  //   resetSizeRem() {
  //     let designSize = 1920;// 设计图尺寸
  //     let html = document.documentElement;
  //     let wW = html.clientWidth; // 窗口宽度
  //     let rem = wW / designSize;
  //     document.documentElement.style.fontSize = rem + "px";
  //     console.log(document.documentElement.style.fontSize, 'rem fontSize');
  //   }
  // },
  created() {
    // this.resetSizeRem()
    // window.onresize = () => {
    //   this.resetSizeRem()
    // }
  }
};
</script>

<style>
#app {
  font-family: PuHuiTi-55, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
}
</style>
